import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import clsx from 'clsx';

/**
 * Price display for cart-line / resume-item rows. Replaces the legacy
 * `<pxw-product-price layout="resume-item">` per the product-price split plan.
 * Receives the line subtotals at list (`price`) and sale (`priceDiscount`)
 * already computed by the parent — dumb.
 */
@Component({
  selector: 'pxw-product-resume-price',
  templateUrl: './product-resume-price.component.html',
  styleUrls: ['./product-resume-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, CurrencyFormatPipe],
})
export class ProductResumePriceComponent {
  price = input.required<number>();
  priceDiscount = input<number>();

  hasPriceDiscount = computed(() => {
    const discount = this.priceDiscount();
    return discount != null && discount < this.price();
  });

  @HostBinding('class')
  get classNames() {
    return clsx({
      'with-discount': this.hasPriceDiscount(),
    });
  }
}
